import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ReportHeader from "../../../../Components/ReportHeader";
import { useGenerateReportMutation } from "../../../../features/Report/reportSlice";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf"; // Import jsPDF
import "jspdf-autotable";
import Papa from "papaparse";
import { saveAs } from "file-saver";



const Report2 = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const year = queryParams.get("year")
    const ReportType = queryParams.get("reportType")
    const GrpID = queryParams.get("groupId")
    const rows = Array(7).fill();
    const [generateReport, { data: reportData, error, isLoading: reportLoading }] = useGenerateReportMutation();

    console.log("REP", reportData)

    const currentData = reportData?.data?.currentYear
    const previosData = reportData?.data?.previousYear


    useEffect(() => {
        const handleReportGeneration = async () => {
            try {
                await generateReport({
                    year,
                    reportType: ReportType,
                    groupId: GrpID,
                }).unwrap();
            } catch (err) {
                console.error("Error generating report:", err);
            }
        };
        handleReportGeneration();
    }, [year, ReportType, GrpID, generateReport]);

    if (reportLoading) return <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "600", fontSize: "20px" }}>Loading...</div>;
    if (error) return <div style={{ height: "100vh", overflow: 'auto', display: "flex", justifyContent: "center", alignItems: "center" }} id="modal_body">
        <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
    </div>;

    const handleTitlevalue = () => {
        switch (ReportType) {
            case "Report_1a_Large":
                return "Table 1A"
            case "Report_1a_Small":
                return "Table 1B"
            case "Report_1a_CCA":
                return "Table 1C"
            case "Report_2a_TotalSpend":
                return "Table 2A"
            case "Report_2a_Subcontracting":
                return "Table 2B"
            case "Report_3a_Large":
                return "Table 3A"
            case "Report_3b_Small":
                return "Table 3B"
            case "Report_3c_Large":
                return "Table 3C"
            case "Report_3d_Small":
                return "Table 3D"
            case "Report_4a_Large":
                return "Table 4A"
            case "Report_4a_Small":
                return "Table 4B"
            case "Report_5a_DVBE":
                return "Table 5A"
            case "Report_5a_LGBTBE":
                return "Table 5B"
            default:
                return "Table";
        }
    }


    const tableHeadReport1 = [
        { label: "" },
        { label: `Total Procurement` },
        { label: "MBE" },
        { label: "WBE" },
        { label: "DVBE" },
        { label: "LGBTBE" },
        { label: "PDBE" },
        { label: "Other 8(a)*" },
        { label: "Total Supplier Diversity" },

        // createData("", "2023 Total Procurement", "MBE", "WBE", "DVBE", "LGBTBE", "PDBE", "Other 8(a)*", "Total Supplier Diversity")
    ];

    const handleText = (value, company) => {
        // console.log("COM", company)
        switch (value) {
            case 0:
                return company
            case 1:
                return "Total Large Utilities"
            case 2:
                return ""
            case 3:
                return "Total Small Utilities"
            case 4:
                return ""
            case 5:
                return "Total Combined"
            case 6:
            default:
                return ""
        }
    }
    const handleTextCell1 = (value, data) => {
        // console.log("COM", company)
        switch (value) {
            case 0:
                return ""
            case 1:
                return currentData?.TotalLargeUtilites?.TotalProcurement || ""
            case 2:
                return "100%"
            case 3:
                return currentData?.TotalSmallUtilites?.TotalProcurement || ""

            case 4:
                return "100%"
            case 5:
                return currentData?.TotalCombined?.TotalProcurement || ""
            case 6:
            default:
                return "100%"
        }
    }
    const handleTextCell2 = (value, data) => {
        // console.log("COM", company)
        switch (value) {
            case 0:
                return ""
            case 1:
                return previosData?.TotalLargeUtilites?.TotalProcurement || ""
            case 2:
                return "100%"
            case 3:
                return previosData?.TotalSmallUtilites?.TotalProcurement || ""

            case 4:
                return "100%"
            case 5:
                return previosData?.TotalCombined?.TotalProcurement || ""
            case 6:
            default:
                return "100%"
        }
    }

    const handleCommonCell = (value, data, key) => {
        // console.log("COM", company)
        switch (value) {
            case 0:
                return "";
            case 1:
                return currentData?.TotalLargeUtilites?.[key] || "";
            case 2:
                return currentData?.TotalLargeUtilites?.[`${key}Percentage`] || "";
            case 3:
                return currentData?.TotalSmallUtilites?.[key] || "";
            case 4:
                return currentData?.TotalSmallUtilites?.[`${key}Percentage`] || "";
            case 5:
                return currentData?.TotalCombined?.[key] || "";
            case 6:
            default:
                return currentData?.TotalCombined?.[`${key}Percentage`] || "";
        }

    }
    const handleCommonCell2 = (value, data, key) => {
        // console.log("COM", company)
        switch (value) {
            case 0:
                return "";
            case 1:
                return previosData?.TotalLargeUtilites?.[key] || "";
            case 2:
                return previosData?.TotalLargeUtilites?.[`${key}Percentage`] || "";
            case 3:
                return previosData?.TotalSmallUtilites?.[key] || "";
            case 4:
                return previosData?.TotalSmallUtilites?.[`${key}Percentage`] || "";
            case 5:
                return previosData?.TotalCombined?.[key] || "";
            case 6:
            default:
                return previosData?.TotalCombined?.[`${key}Percentage`] || "";
        }

    }

    const handleExportXLSX = () => {


        const title = handleTitlevalue(); // Your title here
        const description = `${year} ${handleTitle()}`;
        // Header labels
        const headers = tableHeadReport1.map((header) => header.label);

        // Data rows
        const xlsxData = [];

        // First set of rows
        rows.forEach((itm, ix) => {
            const row = [
                handleText(ix, year), // Customize for the first cell
                handleTextCell1(ix, itm),
                handleCommonCell(ix, itm, "MBE"),
                handleCommonCell(ix, itm, "WBE"),
                handleCommonCell(ix, itm, "DVBE"),
                handleCommonCell(ix, itm, "LGBTBE"),
                handleCommonCell(ix, itm, "PDBE"),
                handleCommonCell(ix, itm, "OTHER8a"),
                handleCommonCell(ix, itm, "TotalSupplierDiversity"),
            ];
            xlsxData.push(row);
        });

        // Second set of rows
        rows.forEach((itm, ix) => {
            const row = [
                handleText(ix, year - 1), // Customize for the first cell
                handleTextCell2(ix, itm),
                handleCommonCell2(ix, itm, "MBE"),
                handleCommonCell2(ix, itm, "WBE"),
                handleCommonCell2(ix, itm, "DVBE"),
                handleCommonCell2(ix, itm, "LGBTBE"),
                handleCommonCell2(ix, itm, "PDBE"),
                handleCommonCell2(ix, itm, "OTHER8a"),
                handleCommonCell2(ix, itm, "TotalSupplierDiversity"),
            ];
            xlsxData.push(row);
        });

        // Prepare the sheet
        const ws = XLSX.utils.aoa_to_sheet([
            [title],        // First row: Title
            [description], 
            [], // Second row: Description
            headers,
            ...xlsxData]);

        // Create a new workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report Data");

        // Export the workbook to XLSX
        XLSX.writeFile(wb, "table_data.xlsx");
    };

    const exportTableToPDF = () => {
        const doc = new jsPDF();

        // Define the header function with title and description
        const addHeader = (doc) => {
            doc.setFontSize(16);
            doc.setTextColor(40);
            doc.text(handleTitlevalue(), 14, 10); // Title

            doc.setFontSize(10);
            doc.setTextColor(60);
            doc.text(
                `${year} ${handleTitle()}`,
                14,
                16,
                { maxWidth: 180 }
            ); // Description (wrapped text)

            doc.setLineWidth(0.5);
            // doc.line(10, 22, 200, 22); // Horizontal line
        };

        // Call the header function for the first page
        addHeader(doc);

        let startY = 28;
        // Define the table headers
        const tableHead = tableHeadReport1.map((header) => header.label);

        // Extract data for the rows
        const tableRows = rows.map((itm, ix) =>
            Array(9)
                .fill(null)
                .map((_, cellIndex) => {
                    switch (cellIndex) {
                        case 0:
                            return handleText(ix, year);
                        case 1:
                            return handleTextCell1(ix, itm);
                        case 2:
                            return handleCommonCell(ix, itm, "MBE");
                        case 3:
                            return handleCommonCell(ix, itm, "WBE");
                        case 4:
                            return handleCommonCell(ix, itm, "DVBE");
                        case 5:
                            return handleCommonCell(ix, itm, "LGBTBE");
                        case 6:
                            return handleCommonCell(ix, itm, "PDBE");
                        case 7:
                            return handleCommonCell(ix, itm, "OTHER8a");
                        case 8:
                            return handleCommonCell(ix, itm, "TotalSupplierDiversity");
                        default:
                            return null;
                    }
                })
        );

        // Optional: Add rows for the second part
        const additionalRows = rows.map((itm, ix) =>
            Array(9)
                .fill(null)
                .map((_, cellIndex) => {
                    switch (cellIndex) {
                        case 0:
                            return handleText(ix, year - 1);
                        case 1:
                            return handleTextCell2(ix, itm);
                        case 2:
                            return handleCommonCell2(ix, itm, "MBE");
                        case 3:
                            return handleCommonCell2(ix, itm, "WBE");
                        case 4:
                            return handleCommonCell2(ix, itm, "DVBE");
                        case 5:
                            return handleCommonCell2(ix, itm, "LGBTBE");
                        case 6:
                            return handleCommonCell2(ix, itm, "PDBE");
                        case 7:
                            return handleCommonCell2(ix, itm, "OTHER8a");
                        case 8:
                            return handleCommonCell2(ix, itm, "TotalSupplierDiversity");
                        default:
                            return null;
                    }
                })
        );

        // Combine rows if needed
        const allRows = [...tableRows, ...additionalRows];

        // Add the table to the PDF
        doc.autoTable({
            startY: startY,
            head: [tableHead],
            body: allRows,
            showHead: "firstPage",
            styles: {
                fontSize: 8, // Adjust font size
                cellPadding: 2, // Add padding to cells
                overflow: "linebreak",
            },
            headStyles: {
                fillColor: [233, 248, 255], // Light blue header background
                textColor: "#000", // Black text color
            },
            bodyStyles: {
                textColor: "#1A1A1A",
            },
        });

        // Save the PDF
        doc.save("table_report.pdf");
    };


    const handleExportCSV = () => {


        const title = handleTitlevalue(); // Your title here
        const description = `${year} ${handleTitle()}`;
        // Header labels
        const headers = tableHeadReport1.map((header) => header.label);

        // Data rows
        const csvData = [];

        // First set of rows
        rows.forEach((itm, ix) => {
            const row = [
                handleText(ix, year), // Customize for the first cell
                handleTextCell1(ix, itm),
                handleCommonCell(ix, itm, "MBE"),
                handleCommonCell(ix, itm, "WBE"),
                handleCommonCell(ix, itm, "DVBE"),
                handleCommonCell(ix, itm, "LGBTBE"),
                handleCommonCell(ix, itm, "PDBE"),
                handleCommonCell(ix, itm, "OTHER8a"),
                handleCommonCell(ix, itm, "TotalSupplierDiversity"),
            ];
            csvData.push(row);
        });

        // Second set of rows
        rows.forEach((itm, ix) => {
            const row = [
                handleText(ix, year - 1), // Customize for the first cell
                handleTextCell2(ix, itm),
                handleCommonCell2(ix, itm, "MBE"),
                handleCommonCell2(ix, itm, "WBE"),
                handleCommonCell2(ix, itm, "DVBE"),
                handleCommonCell2(ix, itm, "LGBTBE"),
                handleCommonCell2(ix, itm, "PDBE"),
                handleCommonCell2(ix, itm, "OTHER8a"),
                handleCommonCell2(ix, itm, "TotalSupplierDiversity"),
            ];
            csvData.push(row);
        });

        // Combine headers and data
        const csvContent = Papa.unparse([
            [title],               // First row: Title
            [description],         // Second row: Description
            [],
            headers,
            ...csvData]);

        // Download CSV
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, "table_data.csv");
    };

    const downloadHandle = (val) => {
        console.log("VL", val)
        if (val === 1) {
            exportTableToPDF()
        }
        if (val === 2) {
            handleExportXLSX()
        }
        if (val === 3) {
            handleExportCSV()
        }

    }




    const handleTitle = () => {
        if (ReportType === "Report_2a_TotalSpend") {
            return `& ${year - 1} Comparative Summary of Large, Small, & Combined Utilities' Supplier Diversity Results`
        }
        if (ReportType === "Report_2a_Subcontracting") {
            return `& ${year - 1} Comparative Summary of Large, Small & Combined Utilities' Diverse Subcontracting Procurement Results`
        }
    }


    return (
        <div>
            <ReportHeader handleClick={reportData?.data?.reportData?.length < 1 ? () => { } : downloadHandle} title={handleTitle()} year={year} report={ReportType}  logo={reportData?.data?.logo}/>

            <div style={{ height: "calc(100vh - 225px)", overflow: 'auto' }} id="modal_body">

                <TableContainer component={Paper} sx={{ marginTop: "0px" }}>
                    {/* {console.log(data, "data")} */}
                    <Table aria-label='customized table'>
                        <TableHead>
                            <TableRow>
                                {tableHeadReport1.map((header, id) => (
                                    <TableCell
                                        key={id}
                                        align='center'
                                        style={{
                                            background: id === 0 ? "#fff" : "#E9F8FF",
                                            fontWeight: "600",
                                            color: "#000000",
                                            fontSize: "14px",
                                            letterSpacing: "0.2px",
                                            whiteSpace: "nowrap"
                                        }}>
                                        {header.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                rows.map((itm, ix) => {
                                    return (
                                        <TableRow sx={{
                                            height: "3.229vw",
                                        }}>
                                            {Array(9) // Assuming there are 9 cells in each row
                                                .fill(null)
                                                .map((_, cellIndex) => {
                                                    // Handle cell-specific logic with a switch case
                                                    const cellContent = (() => {
                                                        switch (cellIndex) {
                                                            case 0:
                                                                return handleText(ix, year); // Customize for the first cell
                                                            case 1:
                                                                return handleTextCell1(ix, itm);
                                                            case 2:
                                                                return handleCommonCell(ix, itm, "MBE");
                                                            case 3:
                                                                return handleCommonCell(ix, itm, "WBE");
                                                            case 4:
                                                                return handleCommonCell(ix, itm, "DVBE");
                                                            case 5:
                                                                return handleCommonCell(ix, itm, "LGBTBE");
                                                            case 6:
                                                                return handleCommonCell(ix, itm, "PDBE");
                                                            case 7:
                                                                return handleCommonCell(ix, itm, "OTHER8a");
                                                            case 8:
                                                                return handleCommonCell(ix, itm, "TotalSupplierDiversity");
                                                            // Add more cases as needed
                                                            default:
                                                                return null; // Default for cells without specific logic
                                                        }
                                                    })();
                                                    // Additional cell styles based on `cellIndex`
                                                    const cellStyle = {
                                                        fontWeight: cellIndex === 0 ? "700" : "400",
                                                        fontSize: "14px",
                                                        color: "#1A1A1A",
                                                        textAlign: ix === 0 && cellIndex === 0 ? "left" : "right",
                                                        border: "1px solid #E6E6E6", // Add border to each cell
                                                        borderTop:
                                                            ix === 0 && cellIndex === 0
                                                                ? "none"
                                                                : "1px solid #E6E6E6", // Remove borderTop only for the first cell of the first row
                                                        backgroundColor:
                                                            ix === 3 || ix === 4 ? "#F6F6F6" : "transparent", // Conditional background color
                                                    };
                                                    return (
                                                        <TableCell sx={cellStyle} key={cellIndex}>
                                                            {cellContent}
                                                        </TableCell>
                                                    );
                                                })}
                                        </TableRow>
                                    )
                                })
                            }
                            {
                                rows.map((itm, ix) => {
                                    return (
                                        <TableRow sx={{
                                            height: "3.229vw",
                                        }}>
                                            {Array(9) // Assuming there are 9 cells in each row
                                                .fill(null)
                                                .map((_, cellIndex) => {
                                                    // Handle cell-specific logic with a switch case
                                                    const cellContent = (() => {
                                                        switch (cellIndex) {
                                                            case 0:
                                                                return handleText(ix, year - 1); // Customize for the first cell
                                                            case 1:
                                                                return handleTextCell2(ix, itm);
                                                            case 2:
                                                                return handleCommonCell2(ix, itm, "MBE");
                                                            case 3:
                                                                return handleCommonCell2(ix, itm, "WBE");
                                                            case 4:
                                                                return handleCommonCell2(ix, itm, "DVBE");
                                                            case 5:
                                                                return handleCommonCell2(ix, itm, "LGBTBE");
                                                            case 6:
                                                                return handleCommonCell2(ix, itm, "PDBE");
                                                            case 7:
                                                                return handleCommonCell2(ix, itm, "OTHER8a");
                                                            case 8:
                                                                return handleCommonCell2(ix, itm, "TotalSupplierDiversity");
                                                            // Add more cases as needed
                                                            default:
                                                                return null; // Default for cells without specific logic
                                                        }
                                                    })();
                                                    // Additional cell styles based on `cellIndex`
                                                    const cellStyle = {
                                                        fontWeight: cellIndex === 0 ? "700" : "400",
                                                        fontSize: "14px",
                                                        color: "#1A1A1A",
                                                        whiteSpace: "nowrap",
                                                        textAlign: ix === 0 && cellIndex === 0 ? "left" : "right",
                                                        border: "1px solid #E6E6E6", // Add border to each cell
                                                        borderTop:
                                                            ix === 0 && cellIndex === 0
                                                                ? "none"
                                                                : "1px solid #E6E6E6", // Remove borderTop only for the first cell of the first row
                                                        backgroundColor:
                                                            ix === 3 || ix === 4 ? "#F6F6F6" : "transparent", // Conditional background color
                                                    };
                                                    return (
                                                        <TableCell sx={cellStyle} key={cellIndex}>
                                                            {cellContent}
                                                        </TableCell>
                                                    );
                                                })}
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>
        </div>
    )
}

export default Report2